export default __webpack_public_path__ + "static/media/Visual_joil_17.4bd80bf6.jpg";